import { useCallback, useEffect, useRef, useState } from "react";
import UI from "../../components/UI";
import Container from "../../libs/react-phaser-fiber/components/Container";
import Text from "../../libs/react-phaser-fiber/components/Text";
import usePhaser from "../../libs/react-phaser-fiber/hooks/usePhaser";
import { SCALE } from "../../utils/constants";
import { translate } from "../../utils/localization";
import CRTFilter from "../../utils/CRTShaderFX";
import { playGlobalScore } from "../../utils/globalScore";

const fontStyle = {
  fontFamily: "GameGirl",
   fontSize: "8px",
  fill: "#aee0c8",
  lineSpacing: 2,
  // fontFamily: "Emulogic",
  // fontSize: "8px",
  // fill: "#aee0c8",
  fontWeight: "regular",
};
const PAGES = {
  PAGE1: "PAGE1",
  PAGE2: "PAGE2",
};
const KiStageCompleted = () => {
  const { game, scene, sceneProps } = usePhaser();
  const [currentPage, setCurrentPage] = useState(PAGES.PAGE1);
  const fullTextDisplayed = useRef(false);
  const page1 = [
    {
      xOffset: 5,
      yOffset: 0,
      text: translate("outro_ki.title"),
      delay: 1000,
    },
    {
      xOffset: 5,
      yOffset: 2,
      text: translate("outro_ki.toBrContinue"),
      delay: 2500,
    },
    {
      xOffset: 1,
      yOffset: 4,
      text: translate("outro_ki.discharge"),
      delay: 1500,
    },
    {
      xOffset: 1,
      yOffset: 5,
      text: translate("outro_ki.whatsNext"),
      delay: 1500,
    },
    {
      xOffset: 1,
      yOffset: 6,
      text: translate("outro_ki.followUs"),
      delay: 1500,
    },
    {
      xOffset: 1,
      yOffset: 7,
      text: translate("outro_ki.ourName"),
      delay: 1500,
    },
    {
      xOffset: 1,
      yOffset: 9,
      text: translate("outro_ki.msgLine1"),
      delay: 1500,
    },
    {
      xOffset: 1,
      yOffset: 10,
      text: translate("outro_ki.msgLine2"),
      delay: 1500,
    },
    {
      xOffset: 1,
      yOffset: 13,
      text: translate("outro_ki.msgLine3"),
      delay: 1500,
    },
  ];
  const page2 = [
    {
      xOffset: 0,
      yOffset: 0,
      text: translate("outro_ki.credits"),
      delay: 500,
    },
    {
      xOffset: 0,
      yOffset: 2,
      text: translate("outro_ki.creditsLine1"),
      delay: 2500,
    },
    {
      xOffset: 0,
      yOffset: 3,
      text: translate("outro_ki.creditsLine2"),
      delay: 1500,
    },
    {
      xOffset: 0,
      yOffset: 4,
      text: translate("outro_ki.creditsLine3"),
      delay: 1500,
    },
    {
      xOffset: 0,
      yOffset: 5,
      text: translate("outro_ki.creditsLine4"),
      delay: 1500,
    },
    {
      xOffset: 0,
      yOffset: 7,
      text: translate("outro_ki.creditsLine5"),
      delay: 3500,
    },
  ];
  const keyDownHandler = useCallback(
    (event) => {
      console.log(event);
      if (
        event.key === "Enter" &&
        currentPage === PAGES.PAGE1 &&
        fullTextDisplayed.current
      ) {
        setCurrentPage(PAGES.PAGE2);
      }
      if (
        event.key === "Enter" &&
        currentPage === PAGES.PAGE2 &&
        fullTextDisplayed.current
      ) {
        // setCurrentPage(PAGES.PAGE2)
      }
    },
    [currentPage, setCurrentPage]
  );
  useEffect(() => {
    if (scene) {
      scene.cameras && scene.cameras.main.setPostPipeline(CRTFilter);
      scene.input.keyboard.addListener("keyup", keyDownHandler);

      playGlobalScore(scene)
    }
    return () => {
      scene?.input.keyboard.off("keyup");
    };
  }, [scene, keyDownHandler]);

  const formatFont = (txt) => {
    txt.displayHeight = 10 * SCALE();
    txt.depth = 16;
    txt.name = "header_text";
    txt.setScale(SCALE());
    txt.setScrollFactor(0);
    txt.setShadow(-1, 1);
  };
  const animate = useCallback(
    (page, idx, txt) => {
      const totalDelay = page.reduce((del, op, i) => {
        if (i <= idx) {
          del += op.delay;
        }
        return del;
      }, 0);
      scene.tweens.add({
        targets: txt,
        alpha: 1,
        ease: "Linear",
        duration: 500,
        delay: totalDelay,
        onComplete: () => {
          if (idx === page.length - 1) {
            fullTextDisplayed.current = true;
          }
        },
      });
      // setTimeout(() => (txt.alpha = 1), totalDelay)
    },
    [scene]
  );

  const CONTAINER_TOP = UI.tileToScreen(1);
  const CONTAINER_LEFT = UI.tileToScreen(1);

  const MARGIN_LEFT = UI.tileToScreen(1);
  const LINE_HEIGHT = UI.tileToScreen(0.75);
  const MENU_OPTIONS_TOP = UI.tileToScreen(7);
  return (
    <>
      {currentPage === PAGES.PAGE1 && (
        <Container x={CONTAINER_LEFT} y={CONTAINER_TOP}>
          {page1.map((op, idx) => (
            <Text
              key={op.text}
              x={MARGIN_LEFT * op.xOffset}
              y={LINE_HEIGHT * op.yOffset}
              setStyle={fontStyle}
              addedToScene={(txt) => {
                txt.alpha = 0;
                animate(page1, idx, txt);
                formatFont(txt);
              }}
              // alpha={1}
            >
              {op.text}
            </Text>
          ))}
        </Container>
      )}
      {currentPage === PAGES.PAGE2 && (
        <Container x={CONTAINER_LEFT} y={CONTAINER_TOP}>
          {page2.map((op, idx) => (
            <Text
              key={op.text}
              x={MARGIN_LEFT * op.xOffset}
              y={LINE_HEIGHT * op.yOffset}
              setStyle={fontStyle}
              addedToScene={(txt) => {
                txt.alpha = 0;
                animate(page2, idx, txt);
                formatFont(txt);
              }}
              // alpha={1}
            >
              {op.text}
            </Text>
          ))}
        </Container>
      )}
    </>
  );
};

export default KiStageCompleted;
